const initialState = {
  assets: [],
  loading: false,
  error: null,
  assetsCount: 0,
  categories: [],
  categoriesLoading: false,
  categoriesError: null,
  // For create asset
  createAssetLoading: false,
  createAssetError: null,
  createAssetSuccess: false,
  // For asset details
  assetDetails: {
    asset: null,
    loading: false,
    error: null,
  },
};

export const assetReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ASSETS_REQUEST":
      return { ...state, loading: true, error: null };
    case "GET_ASSETS_SUCCESS":
      return {
        ...state,
        loading: false,
        assets: action.payload.assets,
        assetsCount: action.payload.assetsCount,
      };
    case "GET_ASSETS_FAIL":
      return { ...state, loading: false, error: action.payload };
    case "GET_ASSET_CATEGORIES_REQUEST":
      return { ...state, categoriesLoading: true, categoriesError: null };
    case "GET_ASSET_CATEGORIES_SUCCESS":
      return {
        ...state,
        categoriesLoading: false,
        categories: Array.isArray(action.payload.categories)
          ? action.payload.categories
          : Array.isArray(action.payload)
          ? action.payload
          : [],
      };
    case "GET_ASSET_CATEGORIES_FAIL":
      return {
        ...state,
        categoriesLoading: false,
        categoriesError: action.payload,
      };
    case "CREATE_ASSET_REQUEST":
      return {
        ...state,
        createAssetLoading: true,
        createAssetError: null,
        createAssetSuccess: false,
      };
    case "CREATE_ASSET_SUCCESS":
      return {
        ...state,
        createAssetLoading: false,
        createAssetSuccess: true,
      };
    case "CREATE_ASSET_FAIL":
      return {
        ...state,
        createAssetLoading: false,
        createAssetError: action.payload,
      };
    case "CREATE_ASSET_RESET":
      return {
        ...state,
        createAssetLoading: false,
        createAssetError: null,
        createAssetSuccess: false,
      };
    case "GET_ASSET_DETAILS_REQUEST":
      return {
        ...state,
        assetDetails: {
          ...state.assetDetails,
          loading: true,
          error: null,
        },
      };
    case "GET_ASSET_DETAILS_SUCCESS":
      return {
        ...state,
        assetDetails: {
          loading: false,
          asset: action.payload.asset,
          error: null,
        },
      };
    case "GET_ASSET_DETAILS_FAIL":
      return {
        ...state,
        assetDetails: {
          loading: false,
          asset: null,
          error: action.payload,
        },
      };
    default:
      return state;
  }
};
